import MojitoCore from 'mojito/core';
import { useState } from 'react';
import MojitoPresentation from 'mojito/presentation';

const classUtils = MojitoCore.Base.classUtils;
const { Button, Image } = MojitoPresentation.Components;

export default function KeypadImageButton(props) {
    const { onClick, onClickData, mojitoTools } = props;
    const {
        config: { button, buttonChildContainer },
        style,
    } = mojitoTools;

    const className = classUtils.classNames('ta-KeypadImageButton', props.class);
    const [active, setActive] = useState(false);

    const imageStyle = active && style.activeImage.src ? style.activeImage : style.inactiveImage;

    return (
        <Button
            config={button}
            onClick={onClick}
            class={className}
            onClickData={onClickData}
            onActiveChange={setActive}
        >
            <div style={buttonChildContainer}>
                <Image config={imageStyle} />
            </div>
        </Button>
    );
}

KeypadImageButton.getStyle = (config, mode, merge) => {
    const { baseImage, activeImage, inactiveImage } = config;
    return {
        activeImage: merge(baseImage, activeImage),
        inactiveImage: merge(baseImage, inactiveImage),
    };
};
